import { BoardEntityTypes } from 'types/Board';
import { CardToShow } from '../types/CardsToShow';
import { StatusCount } from '../types/StatusCount';
import { SummaryCard } from '../types/SummaryCard';
import { summaryCards } from '../constants/summaryCards';

/** TODO: add these translations and descriptions
 * Borrador => En preparación no convocado
 * Agendado =>
 * Convocado =>
 * Celebrado =>
 */

export const getSummaryCards = (
  statusCount: StatusCount,
  cardsToShow: CardToShow,
  boardType: BoardEntityTypes
): SummaryCard[] => {
  const allCards: SummaryCard[] = [
    {
      key: 'preparation-card',
      value: statusCount.preparing,
      title: summaryCards[boardType].preparationCard.title,
      description: summaryCards[boardType].preparationCard.description,
      color: 'info',
      icon: 'ni-clock',
      condition: cardsToShow?.preparing,
    },
    {
      key: 'active-card',
      value: statusCount.active,
      title: summaryCards[boardType].activeCard.title,
      description: summaryCards[boardType].activeCard.description,
      color: 'primary',
      icon: 'ni-calendar-check',
      condition: cardsToShow?.active,
    },
    {
      key: 'sign-pending-card',
      value: statusCount.signPending,
      title: summaryCards[boardType].signPendingCard.title,
      description: summaryCards[boardType].signPendingCard.description,
      color: 'warning',
      icon: 'ni-pen',
      condition: cardsToShow?.signPending,
    },
    {
      key: 'closed-card',
      value: statusCount.closed,
      title: summaryCards[boardType].closedCard.title,
      description: summaryCards[boardType].closedCard.description,
      color: 'success',
      icon: 'ni-check-circle',
      condition: cardsToShow?.closed,
    },
  ];

  return allCards
    .filter((card) => (cardsToShow ? card.condition : true))
    .map(({ condition, ...card }) => card);
};
